import { Spinner as AntdSpinner } from "@empglabs/backoffice-ui-kit"

const Spinner = props => {
  return <AntdSpinner {...props} />
}

export default Spinner
